import styled from "styled-components"

import { minWidth, when } from "utils"

import Table from "components/table"

export const StyledTable = styled(Table)`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 3rem;
  padding: 0 !important;
  border-width: 0.1rem;
  border-style: solid;
  border-color: #222;

  ${when("lockFirstColumnOnMobile")`
    width: calc(100% - 2.7rem);
    margin: 0 0 3rem 2.7rem;
    border-width: 0.1rem 0 0.1rem 0.1rem;
  `}

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
    border-width: 0.1rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}

  ${when("stretch")`
    max-width: unset !important;
  `}

  div:nth-of-type(2) section {
    padding: 0;

    tr {
      th {
        padding: 1rem;
        font-weight: 500;
        font-size: 1.6rem;
        line-height: 1.8rem;

        &:first-of-type {
          background-color: #f3f3f3;
        }

        &:not(:first-of-type) {
          border-bottom: 0.1rem solid #ccc !important;
        }
      }

      td {
        padding: 1rem;
        font-size: 1.6rem;
        line-height: 1.8rem;

        &:first-of-type {
          background-color: #f9f9f9;
        }

        &:not(:first-of-type) {
          color: #00000099;
        }
      }

      &:not(:last-of-type) {
        td:not(:first-of-type) {
          border-bottom: 0.1rem solid #ccc !important;
        }
      }
    }
  }
`
